<template>
  <div ref="audioWrapper">
    <div v-if="mediafile.sources.length > 0" class="player_or_notice">
      <div class="playerWrapper">
        <div>
          <audio
            controls="controls"
            :id="`asset_${mediafile.id}`"
            ref="audioplayer"
            preload="auto"
            :data-event-label="mediafile.id">
            <source :src="mediafile.sources[0].src" type="audio/mpeg">
          </audio>
        </div>
      </div>
    </div>
    <show-processing type="audio" :show="canSeeProcessing" :state="state"></show-processing>
  </div>
</template>
<script>

import { initAudio } from 'audio/init_audio'
import ShowProcessing from './show_processing.vue'
export default {
  components: {
    ShowProcessing
  },
  props: {
    mediafile: {
      type: Object
    },
    canEdit: {
      type: Boolean
    }
  },
  computed: {
    state() {
      return this.mediafile.state
    },
    canSeeProcessing() {
      return this.canEdit && this.mediafile.sources.length < 1
    }
  },
  mounted() {
    initAudio($(this.$refs.audioplayer))
  }
}
</script>
